import React from 'react';
import { useHistory } from 'react-router-dom';
import { ChatBubbleOutline } from '@mui/icons-material';
import { IconButton } from 'library/ui';
import { useOpenMessaging } from './useOpenMessaging';

export default function MessageWorkerButton({ userId, size = 32 }: { userId: number; size?: number }) {
    const history = useHistory();
    const openMessaging = useOpenMessaging();

    if (!openMessaging) return null;

    return (
        <IconButton
            icon={ChatBubbleOutline}
            tooltip="Message"
            size={size}
            onClick={(e) => {
                e.stopPropagation();
                history.push(`/messages/${userId}`);
            }}
        />
    );
}
